import DefaultList from "@Common/DefaultList";
import { handleCopyBuffer, getStatusTag } from "@utils";
import { computed } from "mobx";
import { inject, observer } from "mobx-react";

import { Tag } from "primereact/tag";

import "./style.scss";
import { useNavigationHandler } from "@hook";

const BucketsAddList = inject("mainStore")(
    observer(({ mainStore }) => {
        const navigation = useNavigationHandler();
        const vendors = computed(() => mainStore.getMainStore("suggest.vendors_suggest")).get();

        const handleRowClick = (e) => {
            mainStore.setMainStore("detailData", {});
            navigation(e.originalEvent, `/buckets-add/${e.data._id}`);
        };

        return (
            <DefaultList
                dataKey={"promo_vendor"}
                apiUrl="/promo/buckets"
                keysToGet={["_id", "title", "repayedPromo", "uploadedPromo", "active", "archived", "draft", "vendorId"]}
                titleName="Корзины"
                titleAddButton="корзину"
                keyFilterSearch="title"
                checkbox={false}
                handleRowClick={handleRowClick}
                columns={[
                    {
                        field: "_id",
                        header: "Id",
                        sortable: false,
                        style: { width: "10%", maxWidth: "103px", textOverflow: "ellipsis", overflow: "hidden" },
                        body: (item) => (
                            <div className="id__copy cursor-pointer" onClick={(e) => handleCopyBuffer(e, item, "_id", (val) => mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: `Скопировано`, detail: val }))}>
                                <span className=" text">ID</span>
                                <i className="pi pi-clone"></i>
                            </div>
                        ),
                        type: "text",
                    },
                    {
                        field: "title",
                        body: (item) => <span className="list__name">{item.title}</span>,
                        header: "Название корзины",
                        style: { width: "300px", maxWidth: "300px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
                        sortable: true,
                        type: "text",
                    },

                    {
                        field: "title",
                        body: (item) => {
                            const vendor = vendors ? vendors.find((i) => i._id === item.vendorId) : false;

                            if (vendor) {
                                return <span>{vendor.name}</span>;
                            }
                        },
                        header: "Вендор",
                        sortable: true,
                        type: "text",
                    },
                    {
                        body: (item) => {
                            return (
                                <div className="progress_bar">
                                    <span>{`${item.repayedPromo?.toLocaleString("ru-RU")} из ${item.uploadedPromo?.toLocaleString("ru-RU")}`}</span>
                                    <div
                                        className="green"
                                        style={{
                                            width: `${(item.repayedPromo / item.uploadedPromo) * 100 <= 2 ? 100 : 100 - (item.repayedPromo / item.uploadedPromo) * 100}%`,
                                        }}
                                    />
                                </div>
                            );
                        },
                        header: "Количество ",
                        style: { width: "20%" },
                        type: "remainingPromo",
                    },
                    {
                        body: (item) => {
                            const tag = getStatusTag(item);
                            return <Tag severity={tag.type} icon={tag.icon} />;
                        },
                        header: "Активность",
                        style: { width: "10%" },
                        sortable: false,
                    },
                ]}
            />
        );
    }),
);

export default BucketsAddList;
